import { parseFiniteNumber } from '../../parse-finite-number.js';
import { parsePurchaseOrderQuantity } from './item-quantity.js';
export function emptyPurchaseOrderCreateForm() {
    return {
        locationGroupId: '',
        brandId: '',
        fobPointId: '',
        expectedDeliveryDate: '',
        vendorId: '',
        paymentTermsId: '',
        note: '',
        lines: [],
    };
}
function toOptionalExpectedDeliveryDate(value) {
    const trimmed = value.trim();
    if (!trimmed) {
        return null;
    }
    const parsed = new Date(trimmed);
    return Number.isNaN(parsed.getTime()) ? null : parsed.toISOString();
}
function mapLine(line, headerVendorId) {
    if (line.selected === false || !line.partId) {
        return undefined;
    }
    const quantity = parsePurchaseOrderQuantity(line.quantity);
    if (quantity === undefined) {
        return undefined;
    }
    const unitCost = parseFiniteNumber(line.unitCost);
    return {
        partId: line.partId,
        quantity,
        vendorId: headerVendorId,
        ...(unitCost !== undefined && { unitCost }),
    };
}
export function toCreatePurchaseOrdersFromPartsInput(values) {
    const note = values.note.trim();
    const items = values.lines
        .map((line) => mapLine(line, values.vendorId))
        .filter((item) => item !== undefined);
    const fobPointId = values.fobPointId.trim();
    return {
        locationGroupId: values.locationGroupId,
        brandId: values.brandId,
        vendorId: values.vendorId,
        paymentTermsId: values.paymentTermsId,
        ...(fobPointId && { fobPointId }),
        expectedDeliveryDate: toOptionalExpectedDeliveryDate(values.expectedDeliveryDate),
        note: note || undefined,
        items,
    };
}
//# sourceMappingURL=create-mapper.js.map